<template>
	<div class="indicator_blood_pressure_edit">
		<van-form>
			<div class="form_item">
				<van-cell title="记录档案" :value="params.patientName"></van-cell>
				<!-- <van-field
					label="卒中类型"
					:value="$status.strokeType[params.strokeType]"
					input-align="right"
					readonly
					placeholder="请选择"
					is-link
					@click="pickerTypeVisible = true"
				></van-field> -->
			</div>
			<div class="form_item">
				<van-field
					label="测量日期"
					input-align="right"
					:value="params.measureDate"
					readonly
					placeholder="请选择"
					is-link
					@click="pickerDateVisible = true"
				></van-field>
				<van-field
					label="测量时间"
					input-align="right"
					:value="params.measureTime"
					readonly
					placeholder="请选择"
					is-link
					@click="pickerTimeVisible = true"
				></van-field>
				<van-field
					type="digit"
					label="收缩压（高压）"
					v-model="params.highPressure"
					label-width="8em"
					input-align="right"
					placeholder="请输入(70-250)"
				>
					<template #button>
						<span>mmHg</span>
					</template>
				</van-field>
				<van-field
					type="digit"
					label="舒张压（低压）"
					label-width="8em"
					v-model="params.lowPressure"
					input-align="right"
					placeholder="请输入(40-140)"
				>
					<template #button>
						<span>mmHg</span>
					</template>
				</van-field>
			</div>
		</van-form>

		<foot-button>
			<van-button color="#F5F6F7" block @click="clickDelete" v-if="$route.params.id">
				<span style="color: #1F2329;">删除</span>
			</van-button>
			<van-button type="primary" block @click="clickSubmit">保存</van-button>
		</foot-button>

		<!--卒中类型-->
		<!-- <van-popup v-model="pickerTypeVisible" position="bottom">
			<van-picker
				:value="params.strokeType"
				title="卒中类型"
				show-toolbar
				:columns="strokeTypeOptions"
				@confirm="clickTypePickerConfirm"
				@cancel="pickerTypeVisible = false"
			/>
		</van-popup> -->
		<!--日期-->
		<van-popup v-model="pickerDateVisible" position="bottom">
			<van-datetime-picker
				:value="params.measureDate || new Date()"
				type="date"
				title="选择日期"
				:formatter="$utils.vantDateTimePickerFormatter"
				:max-date="maxDate"
				@confirm="clickDatePickerConfirm"
				@cancel="pickerDateVisible = false"
			/>
		</van-popup>
		<!--时间-->
		<van-popup v-model="pickerTimeVisible" position="bottom">
			<van-datetime-picker
				:value="params.measureTime || $moment().format('HH:mm')"
				type="time"
				title="选择时间"
				:formatter="$utils.vantDateTimePickerFormatter"
				@confirm="clickTimePickerConfirm"
				@cancel="pickerTimeVisible = false"
			/>
		</van-popup>
	</div>
</template>

<script>
import MixinEdit from './mixins/edit'
export default {
    name: 'indicatorBloodPressure',
    data: () => ({
        params: {
            highPressure: '',
            lowPressure: '',
            measureDate: '',
            measureTime: '',
            patientName: '',
            // strokeType: ''
        },
        pickerTypeVisible: false,
        maxDate: new Date()
    }),
    mixins: [MixinEdit],
    computed: {
        strokeTypeOptions () {
            return Object.values(this.$status.strokeType)
        }
    },
    methods: {
        getApi (apiKey) {
            const apis = {
                saveApi: this.$api.indicator.saveBloodPressureRecord,
                updateApi: this.$api.indicator.updateBloodPressureRecord,
                deleteApi: this.$api.indicator.bloodpressureDelete,
                detailApi: this.$api.indicator.bloodpressureDetail
            }
            return apis[apiKey]
        },
        // // 确认选择卒中类型
        // clickTypePickerConfirm (value) {
        //     const index = this.strokeTypeOptions.indexOf(value)
        //     this.$set(this.params, 'strokeType', Object.keys(this.$status.strokeType)[index])
        //     this.pickerTypeVisible = false
        // },
        // 提交校验
        submitVerify () {
            const keysName = {
                highPressure: '舒张压',
                lowPressure: '收缩压',
                measureDate: '测量日期',
                measureTime: '测量时间',
                // strokeType: '卒中类型'
            }
            const emptyItem = Object.entries(this.params).find(item => !item[1])
            if (emptyItem) {
                this.$toast(`请将${keysName[emptyItem[0]]}填写完整`)
                return false
            }
            if (this.params.highPressure > 250 || this.params.highPressure < 70) {
                this.$toast(`收缩压（高压）的值应在70-250范围内`)
                return false
            }
            if (this.params.lowPressure > 140 || this.params.lowPressure < 40) {
                this.$toast(`舒张压（低压）的值应在40-140范围内`)
                return false
            }

            if (parseInt(this.params.lowPressure) >= parseInt(this.params.highPressure)) {
                this.$toast(`舒张压（低压）不能高于收缩压（高压）`)
                return false
            }
            return true
        }
    }
}
</script>

<style scoped lang="less">
.indicator_blood_pressure_edit {
	min-height: calc(100vh - 216px);
	padding: 40px 32px;
	.form_item {
		& + .form_item {
			margin-top: 38px;
		}
		border-radius: 16px;
		overflow: hidden;
	}
}
</style>
<style lang="less">
.indicator_blood_pressure_edit {
	.form_item {
		.van-cell {
			&::after {
				width: 100%;
			}
			padding-top: 32px;
			padding-bottom: 32px;
			.van-cell__title {
				font-family: PingFangSC-Medium;
				font-size: 30px;
				font-weight: normal;
				color: #1f2329;
			}
			.van-cell__value {
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				color: #1f2329;
			}
		}
	}
}
</style>
